
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/garden",
      function () {
        return require("private-next-pages/garden/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/garden"])
      });
    }
  